import { localizeNumber } from "@devforce/trailhead-client-locale";
import { LightningElement, api, wire } from "lwc";
import { LabelsAdapter } from "common/labelsAdapter";
import { createTrack } from "common/track";

var data$7 = {
  appLauncherAssistiveText: "App Launcher",
  helpAssistiveText: "Hilfe",
  logIn: "Anmelden",
  menuOpenAssistiveText: "Menü öffnen",
  menuCloseAssistiveText: "Menü schließen",
  signUp: "Registrieren",
  userNamePlaceholder: "Hallo Trailblazer!",
  userStats: "%{badges} Badges, %{points} Punkte",
  userStatsWithRank: "%{currentRank}, %{badges} Badges, %{points} Punkte",
  userStatsPlaceholder: "Erfassen Sie Ihre Fortschritte",
  skipLink: "Weiter zum Inhalt",
  messages: "Nachrichten",
};
data$7.appLauncherAssistiveText;
data$7.helpAssistiveText;
data$7.logIn;
data$7.menuOpenAssistiveText;
data$7.menuCloseAssistiveText;
data$7.signUp;
data$7.userNamePlaceholder;
data$7.userStats;
data$7.userStatsWithRank;
data$7.userStatsPlaceholder;
data$7.skipLink;
data$7.messages;

var data$6 = {
  appLauncherAssistiveText: "App Launcher",
  helpAssistiveText: "Help",
  logIn: "Log In",
  menuOpenAssistiveText: "Open Menu",
  menuCloseAssistiveText: "Close Menu",
  signUp: "Sign Up",
  userNamePlaceholder: "Hi, Trailblazer!",
  userStats: "%{badges} badges, %{points} points",
  userStatsWithRank: "%{currentRank}, %{badges} badges, %{points} points",
  userStatsPlaceholder: "Start tracking your progress",
  skipLink: "Skip to content",
  messages: "Messages",
};
data$6.appLauncherAssistiveText;
data$6.helpAssistiveText;
data$6.logIn;
data$6.menuOpenAssistiveText;
data$6.menuCloseAssistiveText;
data$6.signUp;
data$6.userNamePlaceholder;
data$6.userStats;
data$6.userStatsWithRank;
data$6.userStatsPlaceholder;
data$6.skipLink;
data$6.messages;

var data$5 = {
  appLauncherAssistiveText: "Iniciador de aplicación",
  helpAssistiveText: "Ayuda",
  logIn: "Iniciar sesión",
  menuOpenAssistiveText: "Abrir menú",
  menuCloseAssistiveText: "Cerrar menú",
  signUp: "Registrarse",
  userNamePlaceholder: "¡Hola Trailblazer!",
  userStats: "%{badges} insignias, %{points} puntos",
  userStatsWithRank: "%{currentRank}, %{badges} insignias, %{points} puntos",
  userStatsPlaceholder: "Empiece a realizar un seguimiento de su progreso",
  skipLink: "Saltar a contenido",
  messages: "Mensajes",
};
data$5.appLauncherAssistiveText;
data$5.helpAssistiveText;
data$5.logIn;
data$5.menuOpenAssistiveText;
data$5.menuCloseAssistiveText;
data$5.signUp;
data$5.userNamePlaceholder;
data$5.userStats;
data$5.userStatsWithRank;
data$5.userStatsPlaceholder;
data$5.skipLink;
data$5.messages;

var data$4 = {
  appLauncherAssistiveText: "Lanceur d'application",
  helpAssistiveText: "Aide",
  logIn: "Connexion",
  menuOpenAssistiveText: "Ouvrir le menu",
  menuCloseAssistiveText: "Fermer le menu",
  signUp: "S'inscrire",
  userNamePlaceholder: "Bonjour Trailblazer !",
  userStats: "%{badges} badges, %{points} points",
  userStatsWithRank: "%{currentRank}, %{badges} badges, %{points} points",
  userStatsPlaceholder: "Suivez votre progression",
  skipLink: "Accéder au contenu",
  messages: "Messages",
};
data$4.appLauncherAssistiveText;
data$4.helpAssistiveText;
data$4.logIn;
data$4.menuOpenAssistiveText;
data$4.menuCloseAssistiveText;
data$4.signUp;
data$4.userNamePlaceholder;
data$4.userStats;
data$4.userStatsWithRank;
data$4.userStatsPlaceholder;
data$4.skipLink;
data$4.messages;

var data$3 = {
  appLauncherAssistiveText: "アプリケーションランチャー",
  helpAssistiveText: "ヘルプ",
  logIn: "ログイン",
  menuOpenAssistiveText: "メニューを開く",
  menuCloseAssistiveText: "メニューを閉じる",
  signUp: "サインアップ",
  userNamePlaceholder: "Trailblazer の皆さん!",
  userStats: "%{badges} 個のバッジ、 %{points} ポイント",
  userStatsWithRank: "%{currentRank}、%{badges} 個のバッジ、%{points} ポイント",
  userStatsPlaceholder: "進行状況の追跡を始める",
  skipLink: "コンテンツにスキップ",
  messages: "メッセージ",
};
data$3.appLauncherAssistiveText;
data$3.helpAssistiveText;
data$3.logIn;
data$3.menuOpenAssistiveText;
data$3.menuCloseAssistiveText;
data$3.signUp;
data$3.userNamePlaceholder;
data$3.userStats;
data$3.userStatsWithRank;
data$3.userStatsPlaceholder;
data$3.skipLink;
data$3.messages;

var data$2 = {
  appLauncherAssistiveText: "앱 시작 관리자",
  helpAssistiveText: "도움말",
  logIn: "로그인",
  menuOpenAssistiveText: "메뉴 열기",
  menuCloseAssistiveText: "메뉴 닫기",
  signUp: "가입",
  userNamePlaceholder: "안녕하세요, Trailblazer 님!",
  userStats: "뱃지 %{badges}개, 포인트 %{points}점",
  userStatsWithRank:
    "%{currentRank} 등급, 뱃지 %{badges}개, 포인트 %{points}점",
  userStatsPlaceholder: "진행 상황을 추적하세요",
  skipLink: "콘텐츠로 건너뛰기",
  messages: "메시지",
};
data$2.appLauncherAssistiveText;
data$2.helpAssistiveText;
data$2.logIn;
data$2.menuOpenAssistiveText;
data$2.menuCloseAssistiveText;
data$2.signUp;
data$2.userNamePlaceholder;
data$2.userStats;
data$2.userStatsWithRank;
data$2.userStatsPlaceholder;
data$2.skipLink;
data$2.messages;

var data$1 = {
  appLauncherAssistiveText: "Iniciador de aplicativos",
  helpAssistiveText: "Ajuda",
  logIn: "Fazer login",
  menuOpenAssistiveText: "Abrir menu",
  menuCloseAssistiveText: "Fechar menu",
  signUp: "Inscrever-se",
  userNamePlaceholder: "Olá, Trailblazer!",
  userStats: "%{badges} emblemas, %{points} pontos",
  userStatsWithRank: "%{currentRank}, %{badges} emblemas, %{points} pontos",
  userStatsPlaceholder: "Comece a acompanhar seu progresso",
  skipLink: "Pular para o conteúdo",
  messages: "Mensagens",
};
data$1.appLauncherAssistiveText;
data$1.helpAssistiveText;
data$1.logIn;
data$1.menuOpenAssistiveText;
data$1.menuCloseAssistiveText;
data$1.signUp;
data$1.userNamePlaceholder;
data$1.userStats;
data$1.userStatsWithRank;
data$1.userStatsPlaceholder;
data$1.skipLink;
data$1.messages;

var data = {
  appLauncherAssistiveText: "应用程序启动器",
  helpAssistiveText: "帮助",
  logIn: "登录",
  menuOpenAssistiveText: "打开菜单",
  menuCloseAssistiveText: "关闭菜单",
  signUp: "注册",
  userNamePlaceholder: "您好，Trailblazer！",
  userStats: "%{badges} 个徽章，%{points} 分",
  userStatsWithRank: "%{currentRank}，%{badges} 个徽章，%{points} 分",
  userStatsPlaceholder: "开始跟踪您的进度",
  skipLink: "跳到内容",
  messages: "消息",
};
data.appLauncherAssistiveText;
data.helpAssistiveText;
data.logIn;
data.menuOpenAssistiveText;
data.menuCloseAssistiveText;
data.signUp;
data.userNamePlaceholder;
data.userStats;
data.userStatsWithRank;
data.userStatsPlaceholder;
data.skipLink;
data.messages;

var locales = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  de: data$7,
  en: data$6,
  esMX: data$5,
  fr: data$4,
  ja: data$3,
  ko: data$2,
  ptBR: data$1,
  zhCN: data,
});

class header extends LightningElement {
  @api config = null; // HACK: Allow Storybook to force the layout

  @api __layout = null;
  track = createTrack(this);
  isMobile = mediaQueryMobileDefault.matches;
  _mediaQueryMobile = mediaQueryMobileDefault;

  get mediaQueryMobile() {
    return this._mediaQueryMobile;
  }

  set mediaQueryMobile(mq) {
    this._mediaQueryMobile.removeEventListener(
      "change",
      this.onMediaQueryChange
    );

    this._mediaQueryMobile = mq;

    this._mediaQueryMobile.addEventListener("change", this.onMediaQueryChange);
  }

  @wire(LabelsAdapter, {
    locales,
    options: "$labelsOptions",
  })
  _labels = {};

  get labels() {
    return {
      ...this._labels,
      userStats: this.userHasStats ? this._labels.userStats : "",
    };
  }

  get labelsOptions() {
    let { config, userHasStats } = this;
    const points =
      userHasStats && config.userProfile?.pointsCount
        ? localizeNumber(config.userProfile.pointsCount)
        : 0;
    const badges = userHasStats ? config.userProfile.badgesCount : 0;
    return {
      userStats: {
        badges,
        points,
      },
      userStatsWithRank: {
        badges,
        points,
        currentRank: userHasStats ? config.userProfile.currentRank : "",
      },
    };
  }

  get logo() {
    return this.isMobile
      ? this.config.logoMobile || this.config.logo
      : this.config.logo;
  }

  get skipLink() {
    return (
      this.config.skipLink ?? {
        href: "#main",
      }
    );
  }

  get style() {
    let styles = [];

    if (this.config.theme) {
      styles.push(
        `--tds-header_theme-color-default: ${this.config.theme.primary}`,
        `--tds-header_theme-color-dark-default: ${this.config.theme.primaryDark}`,
        `--tds-header_theme-color-light-default: ${this.config.theme.primaryLight}`
      );
    }

    return styles.join(";");
  }

  get userHasStats() {
    return (
      this.config &&
      this.config.userProfile &&
      typeof this.config.userProfile.badgesCount === "number" &&
      typeof this.config.userProfile.pointsCount === "number"
    );
  }

  connectedCallback() {
    if (this.__layout) {
      this.isMobile = this.__layout === "mobile";
    } else {
      this.mediaQueryMobile.addEventListener("change", this.onMediaQueryChange);
    }
  }

  disconnectedCallback() {
    this.mediaQueryMobile.removeEventListener(
      "change",
      this.onMediaQueryChange
    );
  }

  handleTrack(e) {
    let eventName = e.detail.eventName;
    this.track(eventName, e.detail.payload);
  }

  onDesktopNavOverflow(e) {
    // If the nav overflows, adjust the mobile media query to be
    // the minimum amount of spaces needed to display the nav without overflow
    if (e.detail.overflow) {
      this.isMobile = true;
      this.mediaQueryMobile = window.matchMedia(
        `(max-width: ${e.detail.minWidth}px)`
      );
    }
  }

  onMediaQueryChange = (e) => {
    this.isMobile = e.matches;
  };
}
const mediaQueryMobileDefault = window.matchMedia("(max-width: 760px)");

export default header;
export { mediaQueryMobileDefault };
